/* eslint-disable no-unused-vars*/
import React, { useState, useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getCookie } from 'helper/cookie';
import { PlusOutlined } from '@ant-design/icons';
import { Button, Row, Col, Form } from 'antd';
import { get } from 'lodash';
import TableTemplateFighthing from './table';
import SearchTemplateFighthing from './search.templateFighthing';
import { getTemplateFighthingAll } from 'api/templateFighthing';
import { getLotteryTypeAll } from 'api/lotteryType';
const initialState = {
   data: [],
   isLoading: true,
   isLoadingCategory: true,
   pagination: {
      total: 0,
      showSizeChanger: false,
      defaultPageSize: 10,
      current: 1,
      limit: 10,
      offset: 0,
      search: '',
      lottery_type_id: 0
   },
   search: {
      order_by: '',
      order_type: '',
   },
};

const TemplateFighthingComponents = () => {
   const isMobileView = useSelector((state) => get(state, 'device.isMobileView', false));
   const navigate = useNavigate();
   const token = getCookie('access_tokenltl');
   const [form] = Form.useForm();
   const dataUser: any = getCookie('dataUser');
   const parseDataUser = dataUser ? JSON.parse(dataUser) : null;
   const [isLoading, setIsLoading] = useState(false);
   const [data, setData] = useState([]);
   const [paginate, setPaginate] = useState<any>(initialState.pagination);
   const [dataLotteryType, setDataLotteryType] = useState<any>([])

   
   const fetchLotteryTypeMyData = useCallback(
      async (query: any) => {
         const params = {
            ids: parseDataUser?.lottery_type
         };
         try {
            const responseData = await getLotteryTypeAll({ token, params: params });
            if (responseData?.status === 200) {
               const { data } = responseData;
               setDataLotteryType(data?.data?.lottery_type);
            } else {
               setDataLotteryType([]);
            }
         } catch (error) {
         }
      },
      [token],
   );

   useMemo(() => {
      if (token && parseDataUser) {
         fetchLotteryTypeMyData(parseDataUser?.lottery_type);
      }
   }, [token]);

   const fetchTemplateFighthingList = useCallback(
      async (query? : any) => {
         setIsLoading(true);
         const params = {
            limit: query?.limit ? query?.limit : paginate.limit,
            offset: query?.offset ? query?.offset : paginate.offset,
            order_by: 'id',
            order_type: 'DESC',
            total: query?.total ? query?.total : paginate.total,
            search: query?.search ? query?.search : null,
            template_fighthing_lottery_type_id: query?.template_fighthing_lottery_type_id ? query?.template_fighthing_lottery_type_id : null,
            groupBy: 'template_fighthing_lottery_type_id'
         };
         try {
            const responseData = await getTemplateFighthingAll({ token, params: params });
            if (responseData?.status === 200) {
               const { data } = responseData;
               setData(data?.data?.template_fighthing);
               setPaginate((prevState : any) => {
                  return {
                     ...prevState,
                     total: data?.data?.total,
                     last_page: (data?.data?.total / prevState.limit),
                     current: prevState.current,
                  };
               });
               setIsLoading(false);
            } else {
               setData([]);
               setPaginate(initialState.pagination);
               setIsLoading(false);
            }
         } catch (error) {
            setIsLoading(false);
         }
      },
      [paginate.limit, token],
   );

   useMemo(() => {
      if (token) {
         fetchTemplateFighthingList();
      }
   }, [token, fetchTemplateFighthingList]);

   const onChangePage = (e : any) => {
      const { current } = e;
      const data = form.getFieldsValue();
      const query = {
         // ...search,
         limit: paginate.limit,
         offset: paginate.limit * (current - 1),
         total: paginate.total,
         search: data?.search,
         lottery_type_id: data?.lottery_type_id,
         current: current,
         showSizeChanger: false,
      };
      setPaginate(query);
      fetchTemplateFighthingList(query);
   };

   const handleSubmit = (values: any) => {
      const search = values?.search;
      const lotteryType = values?.lottery_type_id;
      const query = {
         search: search,
         lottery_type_id: lotteryType || 0
      };
      fetchTemplateFighthingList(query);
   };

   const handleReset = () => {
      form.resetFields();
      setPaginate(initialState.pagination);
      fetchTemplateFighthingList();
   };

   return (
      <Form
         autoComplete="off"
         onFinish={handleSubmit}
         form={form}
         initialValues={{ search: '' }}
      >
         <Row justify="end" gutter={16}>
            <Col>
               <Button
                  type="primary"
                  className="btn-add btn-border-8"
                  onClick={() => navigate('/backoffice/template_fighthing/create', { replace: true })}
                  size='large'
               >
                  <PlusOutlined /> เพิ่มข้อมูลเทมเพลตเลขตั้งสู้
               </Button>
            </Col>
         </Row>
         <div className='mt-4'/>
         <Row justify="end" gutter={16} style={{ marginLeft: '7px' }}>
            <Col span={24}>
               <SearchTemplateFighthing
                  form={form}
                  dataSearch={dataLotteryType}
                  handleSubmit={handleSubmit}
                  handleReset={handleReset}
               />
            </Col>
         </Row>
       
         <div className='mt-3 mb-3'/>
         <TableTemplateFighthing
            isLoading={isLoading}
            data={data}
            renderData={fetchTemplateFighthingList}
            pagination={paginate}
            onChangePage={onChangePage}
            navigate={navigate}
            token={token}
         />
      </Form>
   );
};

export default TemplateFighthingComponents;
